<div class="cowing-input-container">
  <div *ngIf="label.length > 0" class="cowing-input-label">
    {{ label | translate }}
  </div>
  <div class="cowing-input-container">
    <div *ngIf="iconShow  && iconName" [ngClass]="
        fixedIcon ? 'cowing-input-text-icon-fixed' : 'cowing-input-text-icon'
      ">
      <img [src]="getIcon" alt="" />
    </div>
    <input #input *ngIf="!isForm" [ngClass]="['input-' + inputStyle, !iconShow ? 'not-padding' : '']" [type]="type"
      [placeholder]="placeholder" [(ngModel)]="value" (input)="onInputChange($event)" [readOnly]="readonly" />
    <input #input *ngIf="isForm" [ngClass]="[
        control.invalid && control.touched ? 'input-invalid' : '',
        'input-' + inputStyle,
        !iconShow ? 'not-padding' : ''
      ]" [type]="type" [placeholder]="placeholder" [formControl]="control" [readOnly]="readonly" />
  </div>
</div>
